import { Input, InputRightElement } from '@chakra-ui/input';
import { isAddress } from '@ethersproject/address';
import { crucibleFactoryAbi } from 'abi/crucibleFactoryAbi';
import { ethers } from 'ethers';
import { useWeb3React } from 'hooks/web3';
import { useState } from 'react';
import { BiSearch } from 'react-icons/bi';
import { useHistory } from 'react-router';
import { useConfig } from 'store/config';
import { IconButton, InputGroup, useToast } from '@chakra-ui/react';
import { convertTokenIdToAddress } from 'utils/address';

const CrucibleSearch = () => {
  const [crucibleAddress, setCrucibleAddress] = useState('');
  const { provider, chainId = 1 } = useWeb3React();
  const { crucibleFactoryAddress } = useConfig(chainId).config;
  const toast = useToast();
  const history = useHistory();

  const handleSearchCrucible = async (e: any) => {
    e.preventDefault();
    try {
      const parsedAddress = convertTokenIdToAddress(crucibleAddress);
      if (!isAddress(parsedAddress)) {
        throw new Error('Invalid address format');
      }
      const crucibleFactory = new ethers.Contract(
        crucibleFactoryAddress,
        crucibleFactoryAbi,
        provider
      );
      const isInstance = await crucibleFactory.isInstance(parsedAddress);
      if (!isInstance) {
        throw new Error('Not a Crucible address');
      }
      history.push(`/explore/${parsedAddress}`);
    } catch (error: any) {
      toast({
        title: error.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  };

  return (
    <form onSubmit={handleSearchCrucible}>
      <InputGroup minW='320px'>
        <Input
          pl={4}
          value={crucibleAddress}
          onChange={(e) => setCrucibleAddress(e.target.value)}
          size='lg'
          variant='filled'
          borderRadius='xl'
          placeholder='Search crucible address or token ID'
          _focus={{ background: 'whiteAlpha.200' }}
        />
        <InputRightElement mr={1} mt={1}>
          <IconButton
            aria-label='search'
            icon={<BiSearch />}
            variant='ghost'
            bg='whiteAlpha.200'
            onClick={handleSearchCrucible}
          />
        </InputRightElement>
      </InputGroup>
    </form>
  );
};

export default CrucibleSearch;
